/**
 * Do not edit directly, this file was auto-generated.
 * Generated on Mon, 07 Apr 2025 15:11:32 GMT
 * Generated using: yarn nx run tailwind-config:buildTheme
 *
 * Use these tokens in your JavaScript when you have no other alternative, in lieu of Tailwind’s resolveConfig. Prefer using Tailwind CSS classes, @apply, or theme().
 */
const tokens = {
    'spacing.0': '0',
    'spacing.1': '0.25rem',
    'spacing.2': '0.5rem',
    'spacing.3': '0.75rem',
    'spacing.4': '1rem',
    'spacing.5': '1.25rem',
    'spacing.6': '1.5rem',
    'spacing.7': '1.75rem',
    'spacing.8': '2rem',
    'spacing.9': '2.25rem',
    'spacing.10': '2.5rem',
    'spacing.11': '2.75rem',
    'spacing.12': '3rem',
    'spacing.14': '3.5rem',
    'spacing.16': '4rem',
    'spacing.20': '5rem',
    'spacing.24': '6rem',
    'spacing.26': '6.5rem',
    'spacing.28': '7rem',
    'spacing.32': '8rem',
    'spacing.36': '9rem',
    'spacing.40': '10rem',
    'spacing.42': '10.5rem',
    'spacing.44': '11rem',
    'spacing.48': '12rem',
    'spacing.52': '13rem',
    'spacing.56': '14rem',
    'spacing.60': '15rem',
    'spacing.64': '16rem',
    'spacing.66': '16.5rem',
    'spacing.72': '18rem',
    'spacing.80': '20rem',
    'spacing.96': '24rem',
    'spacing.106': '26.5rem',
    'spacing.170': '42.5rem',
    'spacing.px': '0.0625rem',
    'spacing.0.5': '0.125rem',
    'spacing.1.5': '0.375rem',
    'spacing.2.5': '0.625rem',
    'spacing.3.5': '0.875rem',
    'spacing.card': '1.5rem',
    'borderRadius.none': '0',
    'borderRadius.sm': '0.375rem',
    'borderRadius.lg': '0.5rem',
    'borderRadius.card': '0.5rem',
    'borderRadius.full': '624.9375rem',
    'borderWidth.0': '0',
    'borderWidth.2': '0.125rem',
    'borderWidth.4': '0.25rem',
    'borderWidth.8': '0.5rem',
    'borderWidth.DEFAULT': '0.0625rem',
    'fontSize.0': '0',
    'fontSize.xs': '0.75rem',
    'fontSize.sm': '0.875rem',
    'fontSize.base': '1rem',
    'fontSize.lg': '1.125rem',
    'fontSize.xl': '1.375rem',
    'fontSize.2xl': '2.25rem',
    'fontSize.3xl': '4rem',
    'fontSize.4xl': '6.5rem',
    'fontWeight.thin': 100,
    'fontWeight.light': 300,
    'fontWeight.regular': 400,
    'fontWeight.medium': 500,
    'fontWeight.semibold': 600,
    'fontWeight.bold': 700,
    'fontWeight.black': 900,
    'fontWeight.weight-inherit': 'inherit',
    'lineHeight.3': '0.75rem',
    'lineHeight.4': '1rem',
    'lineHeight.5': '1.25rem',
    'lineHeight.6': '1.5rem',
    'lineHeight.7': '1.75rem',
    'lineHeight.8': '2rem',
    'lineHeight.9': '2.25rem',
    'lineHeight.10': '2.5rem',
    'lineHeight.none': '1',
    'lineHeight.tight': '1.25',
    'lineHeight.snug': '1.375',
    'lineHeight.normal': '1.5',
    'lineHeight.relaxed': '1.625',
    'lineHeight.chill': '1.75',
    'lineHeight.very-chill': '2',
    'lineHeight.asleep': '2.25',
    'screens.sm': '31.3125rem',
    'screens.until-md': '45rem',
    'screens.md': '45.0625rem',
    'screens.until-lg': '60rem',
    'screens.lg': '60.0625rem',
    'screens.until-xl': '70rem',
    'screens.xl': '70.0625rem',
};
/**
 * Use in lieu of Tailwind’s resolveConfig
 * @see https://tailwindcss.com/docs/configuration#referencing-in-java-script
 */
export const theme = (key) => tokens[key];
//# sourceMappingURL=theme.js.map